import { PleaseWait } from "lib-core"

export default PleaseWait
